import {Component, OnDestroy, OnInit} from '@angular/core';
import {TaxSiteModel, TaxSiteGroupItem, TaxSiteGroup} from '../../models/tax-sites.model';
import {TaxSitesService} from '../../services/tax-sites.service';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import { FuseSidebarService } from '@barebone-fuse/@fuse/components/sidebar/sidebar.service';
import {select, Store} from '@ngrx/store';
import {getApplicationWithId, ParticleState} from '@shared/store/reducers/particle.reduer';
import {
  SetActivityFeedAction,
  SetCurrentRightSideBarFoldOrNotAction,
  SetCurrentRightSideComponentAction
} from "@shared/components/platform-sidebar/store/platform-sidebar.action";
import {PlatformSidebarState} from "@shared/components/platform-sidebar/store/platform-sidebar.reducer";
import {PlatformSidebarService} from "@shared/components/platform-sidebar/store/platform-sidebar.service";
import {DialogModel} from "@shared/models/dialog.model";
import {DialogService} from "@shared/services/dialog-service";

@Component({
    standalone: false,
    selector: 'particle-tax-sites',
  templateUrl: './tax-sites.component.html',
  styleUrls: ['./tax-sites.component.scss']
})

export class TaxSitesComponent implements OnInit, OnDestroy {
  // taxSites: taxSite[] = [];
  appUrl = '';
  taxSiteModel: TaxSiteModel;
  selectedList: TaxSiteGroupItem[];
  groupedItem;
  groups: any[] = [];
  group1: TaxSiteGroup[] = [];
  group2: TaxSiteGroup[] = [];
  group3: TaxSiteGroup[] = [];
  selectedAlphabet = 'ALL';
  alphabets = [];
  constructor(private store: Store<ParticleState>,
              private taxSitesService: TaxSitesService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private platformSidebarStore: Store<PlatformSidebarState>,
              private platformSidebarService: PlatformSidebarService,
              private sidebarService: FuseSidebarService,
              private dialogService: DialogService) { }

  ngOnInit() {
    this.store.pipe(select(getApplicationWithId, 'ITCE')).subscribe(app => {
      if (app && app.HostUrl) {
        this.appUrl = app.HostUrl;
      }
    });
    this.fuseSplashScreenService.show();

    this.taxSitesService.getTaxSites().subscribe((taxSiteModel) => {
      this.taxSiteModel = taxSiteModel;
      this.UpdateTab(0);
      this.fuseSplashScreenService.hide();
    }, (error) => {
      console.error(error);
      this.fuseSplashScreenService.hide();
    });
    // const activityInfo = {type: 'Tool', 'id': 'itrce-tax-websites', 'title': 'Tax Sites', isDefault: true};
    // this.platformSidebarStore.dispatch(new SetActivityFeedAction(activityInfo));
  }

  onTabChange(tabIndex) {
    // console.log("=====> Tab changed");
    // console.log(tabIndex);
    this.UpdateTab(tabIndex);
  }

  UpdateTab(tabIndex: number) {
    // console.log('=====> Current tabIndex ' + tabIndex);
    if (tabIndex === 0) {
      this.selectedList = this.taxSiteModel.governmentWebsites;
    } else {
      this.selectedList = this.taxSiteModel.otherWebsites;
    }
    this.selectedAlphabet = 'ALL';
  this.groupedItem = this.makeGroup(this.selectedList);
  this.updateAlphabetList(this.groupedItem);
  this.splitIntoGroups(this.groupedItem);
}

  updateAlphabetList(groupedItem) {
    //console.log("====> INSIDE UPDATE ALPHABET LIST")
    this.alphabets = Object.keys(groupedItem);
    //console.log(Object.keys(groupedItem));
  }

  UpdateByAlphabet(alphabet) {
    this.selectedAlphabet = alphabet;
    this.splitIntoGroups(this.groupedItem);
  }

  // for item in items , spl

  makeGroup(selectedList: TaxSiteGroupItem[]) {
    const group = selectedList.reduce((r, a) => {
      r[a.alphabet] = [...r[a.alphabet] || [], a];
      return r;
    }, {});
    return group;
  }

  splitIntoGroups(groupedItems) {
    this.groups = [];
    if (this.selectedAlphabet !== 'ALL') {
      if (groupedItems[this.selectedAlphabet] && groupedItems[this.selectedAlphabet].length) {
        const item: TaxSiteGroup = {
          alphabet: this.selectedAlphabet,
          groupItems: <TaxSiteGroupItem[]>groupedItems[this.selectedAlphabet],
          height: 0
        };
        item.height = item.groupItems.length;
        this.groups = [ [item] ];
      }
    } else {
      const data: TaxSiteGroup[] = [];
      let total = 0;
      for (const [key, value] of Object.entries(groupedItems)) {
        // console.log(`${key}: ${value}`);
        const item: TaxSiteGroup = { alphabet: key, groupItems: <TaxSiteGroupItem[]> value, height: 0 };
        let height = 0;
        item.groupItems.forEach((item: TaxSiteGroupItem) => {
          height += item.websites.length;
        });

        item.height = item.groupItems.length;

        total += item.height;
        data.push(item);
      }
      data.sort((a, b) => {
        if (a.alphabet < b.alphabet) { return -1; } else { return 1; }
      });
      const avg = Math.ceil(total / 3);

      // console.log(`Total height: ${total} and average height ${avg}` );

      let sum = 0;
      let lastIndex = 0;
      for (let i = 0; i < data.length; i++) {
        if (sum + data[i].height > avg) {
         // console.log(`${sum + data[i].height} is exceeding avg. splitting on index ${i} | lastindex : ${lastIndex} `);
       //   console.log(data.slice(lastIndex, i + 1));
          this.groups.push( data.slice(lastIndex, lastIndex === 0 ? i : i + 1) );
          sum = 0;
          lastIndex = lastIndex === 0 ? i : i + 1;
        }
        sum = sum + data[i].height;
      }

      if (lastIndex < data.length - 1) {
        this.groups.push( data.slice(lastIndex));
      }

    //  console.log('Total group found: ' + this.groups.length);
    //  console.log(this.groups);

      // // now we need to split the list int 3 groups
      // this.group1 = data.slice(0, avg);
      // this.group2 = data.slice(this.group1.length, this.group1.length + avg);
      // this.group3 = data.slice(this.group1.length + this.group2.length);
      // console.log(`====> Group 1 Length: ${this.group1.length}`);
      // console.log(`====> Group 2 Length: ${this.group2.length}`);
      // console.log(`====> Group 3 Length: ${this.group3.length}`);
    }
  }

  ngOnDestroy(): void {
    if (this.sidebarService.getSidebar('rightsidebar')) {
      this.sidebarService.getSidebar('rightsidebar').close();
      this.sidebarService.getSidebar('rightsidebar').fold();
    }
    this.platformSidebarService.hideSidebarIcon("Related Law Changes");
    this.platformSidebarStore.dispatch(new SetCurrentRightSideComponentAction(null));
    this.platformSidebarStore.dispatch(new SetCurrentRightSideBarFoldOrNotAction(true));
  }
}
